// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type SelectObjectSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function SelectObjectSvgrepoComsvgIcon(
  props: SelectObjectSvgrepoComsvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 24 24"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M7 5a2 2 0 11-4 0 2 2 0 014 0zm1-.25c0 .414.336.75.75.75h6.5a.75.75 0 000-1.5h-6.5a.75.75 0 00-.75.75zM4.75 8a.75.75 0 00-.75.75v6.5a.75.75 0 001.5 0v-6.5A.75.75 0 004.75 8zm14.5 0a.75.75 0 00-.75.75v6.5a.75.75 0 001.5 0v-6.5a.75.75 0 00-.75-.75zM8.75 20a.75.75 0 010-1.5h6.5a.75.75 0 010 1.5h-6.5zM5 21a2 2 0 100-4 2 2 0 000 4zM21 5a2 2 0 11-4 0 2 2 0 014 0zm-2 16a2 2 0 100-4 2 2 0 000 4z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  );
}

export default SelectObjectSvgrepoComsvgIcon;
/* prettier-ignore-end */
